export const MAX_PENDING_ACTION_DURATION_MS = 25_000;
